export const fullReports = {
    "ТЭИ - Базовый отчет": "standard",
    "ТЭИ - Экспертный отчет": "full",
    "ТЭИ - Управленческий потенциал": "management",
    "ТЭИ - Отчет для исследований": "empty",
};

export const shortReports = {
    "Базовый отчет": "standard",
    "Экспертный отчет": "full",
    "Управленческий потенциал": "management",
    "Отчет для исследований": "empty",
};